
export class RefDeliveryinformation {
    startingPeriod:string = ""; //Format day-month
    endingPeriod:string = ""; //Format day-month
    monday:string[] = [];
    tuesday:string[]= [];
    wednesday:string[]= [];
    thursday:string[]= [];
    friday:string[]= [];
    saturday:string[]= [];
    sunday:string[]= [];
}